import React from 'react';

const customizationContextInitialState = {
  customHabitCollection: null,
  appCustomizationDoc: null,
  customCheckInCollection: null,
};

const CustomizationContext = React.createContext(customizationContextInitialState);

export default CustomizationContext;
export {
  customizationContextInitialState,
};
